import Axios from "../utils/Axios";

export const getAttdToday = async () => {
  const response = await Axios.get("/attendance/");
  return response.data;
};

export const getAttdYesterday = async () => {
  const response = await Axios.get("/attendance/yesterday");
  return response.data;
};

export const getAttdTwoDay = async () => {
  const response = await Axios.get("/attendance/twoday");
  return response.data;
};

export const getAttdMonth = async () => {
  const response = await Axios.get("/attendance/month");
  return response.data;
};

export const getAttdPastMonth = async () => {
  const response = await Axios.get("/attendance/past-month");
  return response.data;
};

export const getAttdMonthById = async (empId) => {
  const response = await Axios.get("/attendance/month/id", {
    params: { emp: empId },
  });
  return response.data;
};

export const getHoursPastMonth = async () => {
  const response = await Axios.get("/attendance/past-month/hours");
  return response.data;
};

export const getAttdPastMonthById = async (empId) => {
  const response = await Axios.get("/attendance/past-month/id", {
    params: { emp: empId },
  });
  return response.data;
};

export const getHoursPastMonthSunday = async () => {
  const response = await Axios.get("/attendance/past-month/sunday");
  return response.data;
};

// getting the holiday count
export const getAttdPastMonthSheet = async (holiday) => {
  try {
    const response = await Axios.get(
      `/attendance/past-month-sheet/?holidays=${holiday}`,
      {
        responseType: "blob", // for the excel  file
        timeout: 20000, // timeout changed for this request
      }
    );
    // Create a blob URL for the file
    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = "attendance.xlsx";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

    // Optionally, revoke the blob URL after use
    window.URL.revokeObjectURL(url);
    return response.data;
  } catch (error) {
    console.error("Error downloading file:", error);
  }
};

export const getAttdYearCount = async (signal?: AbortSignal) => {
  const response = await Axios.get("attendance/present-count-years/", {
    signal,
  });
  return response.data;
};
